module.exports = __webpack_public_path__ + "img/Lakala.5666de98.jpg";